import { AppContext } from "./app-context";

export class BrowserEntry {
    constructor(options = {}) {
        this.context = new AppContext(options.context);
    }
    get registry() {
        return this.context.registry;
    }
    get factory() {
        return this.context.factory;
    }
    get released() {
        return this.context.released;
    }
    installPlugin(plugin) {
        this.context.installPlugin(plugin);
    }
    installPlugins(plugins) {
        this.context.installPlugins(plugins);
    }
    uninstallPlugin(name) {
        this.context.uninstallPlugin(name);
    }
    createStage(params = {}) {
        return this.context.createStage(params);
    }
    release() {
        this.context.release();
    }
}

export function createBrowserApp(options = {}) {
    return new BrowserEntry(options);
}
//# sourceMappingURL=browser.js.map
